import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Board from '../components/Board';
import ModalGame from '../components/ModalGame';
import ModalSoal from "../components/ModalSoal";
import ButtonBack from '../components/buttonBack';
import '../App.css';
import ButtonFull from '../components/buttonfull';
import backgroundMusic from '../components/music/game.ogg';
import ButtonMute from '../components/ButtonMusic';
import ModalNameInput from '../components/ModalNameInput';
import Tutorial from '../components/ModalTutorial';
import ButtonTanya from '../components/ButtonTanya';
import ModalExit from '../components/ModalExit';
import Preloader from '../components/preloader';
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../components/language/en/translation_en.json";
import translationID from "../components/language/id/translation_id.json";
import ButtonLanguage from '../components/ButtonLanguage';

const resources = {
  en: {
    translation: translationEN,
  },
  id: {
    translation: translationID,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
const Game = () => {
  const { t } = useTranslation();
  const [pits, setPits] = useState([4, 4, 4, 4, 4, 4, 0, 4, 4, 4, 4, 4, 4, 0]);
  const [currentPlayer, setCurrentPlayer] = useState(0);
  const [isModalGameOpen, setIsModalGameOpen] = useState(false);
  const [isModalSoalOpen, setIsModalSoalOpen] = useState(false);
  const [winner, setWinner] = useState('');
  const [score, setScore] = useState(0);
  const [englishscore0, setEnglishScore0] = useState(0);
  const [englishscore1, setEnglishScore1] = useState(0);
  const [showRotateMessage, setShowRotateMessage] = useState(false);
  const [player1Name, setPlayer1Name] = useState('');
  const [player2Name, setPlayer2Name] = useState('');
  const [isNameModalOpen, setIsNameModalOpen] = useState(true);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [isAnswer, setIsAnswer] = useState(false);
  const [showTutorialModal, setshowTutorialModal] = useState(false);
  const [showModalExit, setModalExit] = useState(false);
  const { selectedCategory } = useParams();
  const category = selectedCategory;
  const [isLoading, setIsLoading] = useState(true);  

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  const handleOpenTutorialModal = () => {
    setshowTutorialModal(true);
  };

  const handleCloseTutorialModal = () => {
    setshowTutorialModal(false);
  };

  const [isplayagain, setplayagain] = useState(false);

  document.body.addEventListener('mousedown', function () {

    document.body.classList.add('clicked');
  });

  document.body.addEventListener('mouseup', function () {

    document.body.classList.remove('clicked');
  });

  const handleMuteToggle = () => {
    console.log('Mute button clicked');
  };

  const handleFullscreenChange = () => {
    if (document.fullscreenElement) {
      setIsFullscreen(true);
    } else {
      setIsFullscreen(false);
    }
  };

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error(`Failed to enable fullscreen mode: ${err.message}`);
      });
    } else {
      document.exitFullscreen().catch(err => {
        console.error(`Failed to exit fullscreen mode: ${err.message}`);
      });
    }
  };

  useEffect(() => {
    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    document.addEventListener('fullscreenchange', handleFullscreenChange);

     try {
       const gameHistory = localStorage.getItem("gameDakonHistory");


       if (!gameHistory || gameHistory.length === 0) {
         console.log("No game history found, closing modal...");
         setshowTutorialModal(true); 
       }
     } catch (error) {
       console.error("Error accessing localStorage:", error);
       setshowTutorialModal(false);; 
     }

    if (document.fullscreenElement) {
      setIsFullscreen(true);
    } else {
      setIsFullscreen(false);
    }

    return () => {
      window.removeEventListener('resize', checkOrientation);
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const checkOrientation = () => {
    if (window.innerHeight > window.innerWidth) {
      setShowRotateMessage(true);
    } else {
      setShowRotateMessage(false);
    };
  };

  useEffect(() => {
    document.title = "Congklak Champs - Game Play";
    checkOrientation();
    window.addEventListener('resize', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
    };
  }, []);

  const handlePitClick = (clickedIndex) => {
    let newPits = [...pits];
    const playerSide = currentPlayer === 0 ? [0, 1, 2, 3, 4, 5] : [7, 8, 9, 10, 11, 12];


    if (playerSide.includes(clickedIndex) && newPits[clickedIndex] !== 0) {
      handleCloseModalSoal();
      setplayagain(false);
      setIsModalSoalOpen(true);
      let stones = newPits[clickedIndex];
      newPits[clickedIndex] = 0;
      let currentIndex = clickedIndex;
      while (stones > 0) {
        currentIndex = (currentIndex + 1) % 14;
        if (
          (currentPlayer === 0 && currentIndex === 13) ||
          (currentPlayer === 1 && currentIndex === 6)
        ) {
          continue;
        }
        newPits[currentIndex]++;
        stones--;
      }

 
      if ((currentPlayer === 0 && currentIndex === 6) || (currentPlayer === 1 && currentIndex === 13)) {
        const allPitsEmpty = playerSide.every(index => newPits[index] === 0);
        if (allPitsEmpty) {
          setCurrentPlayer((prevPlayer) => 1 - prevPlayer);
        } else {
          setplayagain(true)
          setPits(newPits);
          return;
        }
      }

      if (newPits[currentIndex] === 1 && playerSide.includes(currentIndex)) {
        const oppositeIndex = 12 - currentIndex;
        const oppositeStones = newPits[oppositeIndex];


        if (oppositeStones !== 0) {
          newPits[oppositeIndex] = 0;
          newPits[currentIndex] = 0;
          newPits[currentPlayer === 0 ? 6 : 13] += oppositeStones + 1;
        }
      }
      setPits(newPits);

      if (isGameFinished(newPits)) {
        const winner = determineWinner(newPits);
        const score = winner === player1Name ? newPits[6] : newPits[13];
        setWinner(winner);
        setScore(score);
        setIsModalGameOpen(true);
      }
    }
  };
  const handleCloseModalSoal = () => {
    setIsModalSoalOpen(false);
  };

  const isGameFinished = (pits) => {
    return pits.slice(0, 6).every((stones) => stones === 0) || pits.slice(7, 13).every((stones) => stones === 0);
  };

  const determineWinner = (pits) => {
    const player1Score = pits[6];
    const player2Score = pits[13];
    if (player1Score > player2Score) {
      return player1Name;
    } else if (player2Score > player1Score) {
      return player2Name;
    } else {
      return "It's a tie!";
    }
  };

  const handleReset = () => {
    setPits([4, 4, 4, 4, 4, 4, 0, 4, 4, 4, 4, 4, 4, 0]);
    setCurrentPlayer(0);
    setIsModalGameOpen(false);
    setWinner('');
    setScore(0);
    setIsNameModalOpen(true);
  };

  const handleCloseModalGame = () => {
    setIsModalGameOpen(false);
  };

  const handleSaveNames = (player1, player2) => {
    setPlayer1Name(player1);
    setPlayer2Name(player2);
  };


  return (
    <>
      {isLoading ? (
        <Preloader />
      ) : (
        <div className="gamescreen clicked flex flex-col items-center justify-center h-screen relative w-full p-5 box-border">
          {showRotateMessage && (
            <div id="rotate-message">{t("rotate_device")}</div>
          )}

          <div
            className={`current-player ${
              currentPlayer === 0 ? "bg-[#059212]" : "bg-[#FB792F]"
            } sm:p-2 sm:px-4 sm:text-xs lg:text-xl`}
          >
            <p className="text-white font-bold">
              {currentPlayer === 0
                ? `${t("turn")} ${player1Name}`
                : `${t("turn")} ${player2Name}`}
            </p>
          </div>
          <div className="button-container absolute right-5 z-30 justify-between">
            <div className="right-5 z-30 flex gap-3">
              <ButtonBack
                setModalExit={setModalExit}
                player1Score={pits[6]}
                player2Score={pits[12]}
              />
              <ButtonTanya onClick={handleOpenTutorialModal} className="ml-4" />
              <audio
                id="background-audio"
                src={backgroundMusic}
                autoPlay
                loop
              />
              <ButtonMute onClick={handleMuteToggle} />
              <ButtonFull
                isFullscreen={isFullscreen}
                onClick={toggleFullscreen}
                className="top-left-button"
              />
              <ButtonLanguage/>
            </div>

            <div>
              <div className="board-score flex p-4 flex-col items-center">
                <div className="font-bold lg:text-lg lg:mt-4 text-[#8f5732] sm:text-sm sm:mt-3">
                  Quiz Score
                </div>
                <div className="flex lg:mb-2">
                  <div className="score-board1 sm:p-2 lg:py-10 lg:w-[12rem] sm:h-[3rem] sm:w-[7rem]">
                    <p className="text-white font-bold sm:text-xs lg:text-lg ">
                      {player1Name + ": " + englishscore0}
                    </p>
                  </div>
                  <div className="score-board2 sm:p-2 lg:py-10  lg:w-[12rem] sm:h-[3rem] sm:w-[7rem]">
                    <p className="text-white font-bold sm:text-xs lg:text-lg">
                      {player2Name + ": " + englishscore1}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="game flex flex-col items-center w-full mt-5">
            <Board
              pits={pits}
              onPitClick={handlePitClick}
              player1Name={player1Name}
              player2Name={player2Name}
            />

            <ModalGame
              show={isModalGameOpen}
              winner={winner}
              player1Name={player1Name}
              player2Name={player2Name}
              Englishscore0={englishscore0}
              Englishscore1={englishscore1}
              player1Score={pits[6]}
              player2Score={pits[12]}
              score={score}
              onReset={handleReset}
              onClose={handleCloseModalGame}
            />
            <ModalExit
              show={showModalExit}
              onClose={() => setModalExit(false)}
              player1Name={player1Name}
              player2Name={player2Name}
              SetEnglishScore0={setEnglishScore0}
              SetEnglishScore1={setEnglishScore1}
              Englishscore0={englishscore0}
              Englishscore1={englishscore1}
              player1Score={pits[6]}
              player2Score={pits[12]}
            />
            <ModalSoal
              show={isModalSoalOpen}
              onClose={handleCloseModalSoal}
              isAnswer={setIsAnswer}
              currentPlayer={currentPlayer}
              isplayagain={isplayagain}
              setCurrentPlayer={setCurrentPlayer}
              SetEnglishScore0={setEnglishScore0}
              SetEnglishScore1={setEnglishScore1}
              Englishscore0={englishscore0}
              Englishscore1={englishscore1}
              selectedTopic={category}
            />
          </div>
          <Tutorial
            show={showTutorialModal}
            handleClose={handleCloseTutorialModal}
          />
          <ModalNameInput
            show={isNameModalOpen}
            onClose={() => setIsNameModalOpen(false)}
            onSave={handleSaveNames}
          />
          <Tutorial
            show={showTutorialModal}
            handleClose={handleCloseTutorialModal}
          />
        </div>
      )}
    </>
  );
};

export default Game;
